import Swiper, { Controller, Navigation, Pagination } from 'swiper';
import { ancestorBySelector } from '../helpers/element/findAncestor';

Swiper.use([Controller, Navigation, Pagination]);

function expand(carousel) {
    const position = carousel.getBoundingClientRect();
    const viewport = window.innerWidth;

    carousel.style.setProperty('--carousel-width', `${viewport - position.left}px`);
}

function getOptions(carousel) {
    const id = carousel.dataset.carousel;
    let prevEl = carousel.querySelector('.swiper-button-prev');
    let nextEl = carousel.querySelector('.swiper-button-next');

    if (id === 'product') {
        return {
            speed: 400,
            spaceBetween: 0,
            loop: true,
            slidesPerView: 1,
            centeredSlides: true,
            initialSlide: 0,
            navigation: {
                prevEl: document.querySelector('#product-nav-prev'),
                nextEl: document.querySelector('#product-nav-next'),
            },
            pagination: {
                el: document.querySelector(`#product-pagination`),
                type: "fraction",
            },
            on: {
                slideChange: (swiper) => {
                    const slide = swiper.slides[swiper.activeIndex];
                    const slideImage = slide.querySelector('img');

                    if (slideImage !== null) {
                        const caption = slideImage.dataset.caption;
                        const captionArea = document.querySelector('.product-carousel-caption__text');

                        if (captionArea !== null) {
                            if (caption == "" || caption === undefined) {
                                captionArea.innerHTML = '&nbsp;';
                            } else {
                                captionArea.innerHTML = caption;
                            }

                        }
                    }
                },
            },
        };
    }

    if (id === 'banner') {
        const parent = ancestorBySelector(carousel, '.banner');
        const pagination = parent.querySelector('.banner-carousel__nav-pagination');

        return {
            speed: 400,
            spaceBetween: 0,
            loop: true,
            slidesPerView: 1,
            centeredSlides: true,
            initialSlide: 0,
            navigation: {
                prevEl: parent.querySelector('#banner-carousel-nav-prev'),
                nextEl: parent.querySelector('#banner-carousel-nav-next'),
            },
            pagination: {
                el: pagination,
                type: 'fraction',
            },
        };
    }

    if (id === 'project') {
        const parent = ancestorBySelector(carousel, '.project-carousel');
        const pagination = parent.querySelector('.project-carousel__nav-pagination');

        return {
            speed: 400,
            spaceBetween: 0,
            loop: true,
            slidesPerView: 1,
            centeredSlides: true,
            initialSlide: 0,
            navigation: {
                prevEl: parent.querySelector('#project-carousel-nav-prev'),
                nextEl: parent.querySelector('#project-carousel-nav-next'),
            },
            pagination: {
                el: pagination,
                type: 'fraction',
            },
        };
    }

    // Default
    return {

        speed: 400,
        spaceBetween: 0,
        loop: false,
        slidesPerView: 'auto',
        autoplay: false,
        centeredSlides: false,
        initialSlide: 0,
        navigation: {
            prevEl,
            nextEl,
        },
        observer: true,
        observeParents: true,
        on: {
            beforeInit: () => {
                if (carousel.dataset.expand === 'true') {
                    expand(carousel);
                    window.addEventListener('resize', () => {
                        expand(carousel);
                    });
                }
            },
        },
    };
}

export function initCarousel() {
    const carousels = document.querySelectorAll('.js-carousel');
    if (carousels.length > 0) {
        carousels.forEach((carousel) => {
            setTimeout(() => {
                const swiper = new Swiper(carousel, getOptions(carousel));
                carousel.swiper = swiper; // eslint-disable-line no-param-reassign    

                // Product Additional Nav
                const productPrev = document.querySelector('#product-nav-prev-second');
                const productNext = document.querySelector('#product-nav-next-second');

                if (productPrev !== null) {
                    productPrev.addEventListener('click', (event) => {
                        event.preventDefault();
                        swiper.slidePrev();
                    });
                }
                
                if (productNext !== null) {
                    productNext.addEventListener('click', (event) => {
                        event.preventDefault();
                        swiper.slideNext();
                    });
                }

                // Banner Additional Nav
                const bannerParent = ancestorBySelector(carousel, '.banner');
                if (bannerParent) {
                    const bannerPrev = bannerParent.querySelector('#banner-carousel-nav-prev-second');
                    const bannerNext = bannerParent.querySelector('#banner-carousel-nav-next-second');

                    if (bannerPrev !== null) {
                        bannerPrev.addEventListener('click', (event) => {
                            event.preventDefault();
                            swiper.slidePrev();
                        });
                    }
                    
                    if (bannerNext !== null) {
                        bannerNext.addEventListener('click', (event) => {
                            event.preventDefault();
                            swiper.slideNext();
                        });
                    }
                }
                
                // Project Additional Nav
                const projectParent = ancestorBySelector(carousel, '.project-carousel');
                if (projectParent) {
                    const projectPrev = projectParent.querySelector('#project-carousel-nav-prev-second');
                    const projectNext = projectParent.querySelector('#project-carousel-nav-next-second');

                    if (projectPrev !== null) {
                        projectPrev.addEventListener('click', (event) => {
                            event.preventDefault();
                            swiper.slidePrev();
                        });
                    }
                    
                    if (projectNext !== null) {
                        projectNext.addEventListener('click', (event) => {
                            event.preventDefault();
                            swiper.slideNext();
                        });
                    }
                }

            }, 50);

        });
    }
}